import { Link } from "react-router-dom";
import { articlePreviews } from "@/mocks/articles";

export default function ArticlePreview() {
  return (
    <section className="w-full bg-background-100 px-6 md:px-10 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 tracking-tight">
            <span className="text-foreground-400">( </span>
            SEO Guides
            <span className="text-foreground-400"> )</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            Expert insights on maximizing your{" "}
            <strong>pandabuyspreadsheet</strong> experience — {articlePreviews.length} in-depth articles
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articlePreviews.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-50/80 cursor-pointer flex flex-col"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500 font-label">
                    {article.date}
                  </span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-sm text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.summary}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-xs text-primary-500">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}